export const setTriangleBottomMargins = () => {
    $('.triangle-bottom').each(function () {
        // Get the margin of the parent element.

        // Have we already got the margin for the parent?
        let parentMargin = 0;

        if ($(this).data('base-margin')) {
            parentMargin = parseInt($(this).data('base-margin'));
        } else {
            parentMargin = parseInt($(this).parent().css('margin-bottom'));
            $(this).data('base-margin', parentMargin);
        }

        // Get the height of this element.
        const height = Math.round(parseInt($(this).find('.left')[0].getBoundingClientRect().height));

        // Set the margin of this element to the height of the parent element.
        $(this).parent().attr('style', 'margin-bottom: ' + (height + parentMargin) + 'px !important');
    });
};
